import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import NoDataRow from "@/components/simple-table/no-data-row";

const GraphTable = ({
  value = 0,
  loading = false,
  columns = [
    {
      title: "Lead Generated",
      name: "",
    },
    {
      title: "Over Time",
      name: "",
    },
  ],
  data = [],
  renderHeader,
  unit = "",
}) => {
  const headerContent = renderHeader ? (
    renderHeader({ value, loading, data })
  ) : (
    <Box
      sx={{
        width: "max-content",
        background: "var(--palette-stroke)",
        color: "var(--palette-secondary_button_text)",
        borderRadius: "10px",
        px: 4,
        py: 3,
        fontSize: "54px",
        fontWeight: 700,
        mb: 2,
      }}
    >
      {loading ? <CircularProgress size={"17px"} /> : `${value}${unit}`}
    </Box>
  );

  return (
    <Card>
      <CardContent
        className="custom-scroll"
        sx={{ height: "calc(100vh - 165px)", overflowY: "auto", mb: 1 }}
      >
        {headerContent}
        {/* grid */}
        <Box>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: "auto" }} aria-label="simple table">
              <TableHead sx={{ background: "#F2FAFB" }}>
                <TableRow>
                  {columns.map((col, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        width: col.width || "200px",
                        background: "var(--palette-grid_header)",
                        borderColor: "var(--palette-stroke)",
                        color: "var(--palette-heading)",
                      }}
                    >
                      {col.title}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((dt, index) => (
                  <TableRow
                    key={index}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    {columns.map((col, index) => {
                      return (
                        <TableCell
                          key={index}
                          component="th"
                          scope="row"
                          sx={{
                            background: "var(--palette-container)",
                            borderColor: "var(--palette-stroke)",
                            color: "var(--palette-text)",
                          }}
                        >
                          {col?.render
                            ? col.render(dt, col.name)
                            : dt[col.name]?.toString()?.trim() || "N/A"}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ))}
              </TableBody>
              {!data?.length && (
                <NoDataRow
                  columnsLength={columns.length}
                  message={"No records available"}
                  withBody={true}
                />
              )}
            </Table>
          </TableContainer>
        </Box>
      </CardContent>
    </Card>
  );
};

export default GraphTable;
